import * as React from 'react'

import { useMutation } from '@connectrpc/connect-query'
import { useTranslation } from 'react-i18next'

import { Box, Flex, Text } from '@chakra-ui/react'

import {
  ModalView,
  PrimaryButton,
  toaster,
} from '@enechain/ecloud-designsystem'

import CancelButton from '~/components/parts/CancelButton'
import { sendInvitation } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { Member } from '~/gen/proto/bff/v1/model_pb'

type Props = {
  open: boolean
  onClose: () => void
  member: Member
}

const ReSendInvitationModal: React.FC<Props> = ({ member, open, onClose }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'pages.members',
  })

  const { mutate, isPending: isSendingInvitation } = useMutation(
    sendInvitation,
    {
      onSuccess: () => {
        toaster.create({
          title: t('action.resendInvitation.success'),
          description: t('action.resendInvitation.success_to', {
            email: member.email,
          }),
          type: 'success',
        })
      },
      onError: () => {
        toaster.create({
          title: t('action.resendInvitation.error'),
          description: t('action.resendInvitation.error_to', {
            email: member.email,
          }),
          type: 'error',
        })
      },
    },
  )

  const onSubmit = (): void => {
    void mutate({
      memberId: member.id,
    })
    onClose()
  }
  return (
    <ModalView
      bodyChildren={
        <Flex flexDirection="column" gap="4">
          <Text>{t('action.resendInvitation.description')}</Text>
          <Box
            padding="4"
            borderWidth="1px"
            borderColor="Border.midEmphasis"
            borderRadius="radiiMd"
          >
            <Text textStyle="headerMd">{member.name}</Text>
            <Text>{member.email}</Text>
          </Box>
        </Flex>
      }
      footerChildren={
        <Flex justifyContent="flex-end" gap="2">
          <CancelButton onClick={onClose} />
          <PrimaryButton loading={isSendingInvitation} onClick={onSubmit}>
            {t('action.resendInvitation.button')}
          </PrimaryButton>
        </Flex>
      }
      open={open}
      onClose={onClose}
      title={t('action.resendInvitation.title')}
    />
  )
}

export default React.memo(ReSendInvitationModal)
